// @ts-strict-ignore
import React from 'react';
import type { OptionProps } from '@usealloy/component-library';
import { MultiSelectComponents, Checkbox, Tooltip } from '@usealloy/component-library';
import {
  StyledOptionTextDescription,
  StyledOptionName,
  StyledOptionContainer,
  StyledIconContainer,
} from './styles';
import type { BaseAddActionOptionType } from '../types';


interface BaseAddActionOptionProps<Option extends BaseAddActionOptionType>
  extends OptionProps<Option, true> {
  shouldShowCheckbox: boolean;
}

/**
 * Generic component to render a dropdown Option that adheres to the needs of all
 * Add Service modals that compose BaseAddActionModal.
 */
export default function BaseAddActionOption<Option extends BaseAddActionOptionType>(
  props: BaseAddActionOptionProps<Option>,
) {
  const {
    data: {
      label,
      meta: {
        description,
        color,
        toolTipProps,
      },
      icon = React.Fragment,
    },
    isSelected,
    isDisabled: disabled,
    shouldShowCheckbox,
  } = props;
  const isDisabled = Boolean(isSelected || disabled);

  const Description = typeof description === 'string'
    ? <StyledOptionTextDescription size={1}>{description}</StyledOptionTextDescription>
    : description;

  return (
    <MultiSelectComponents.Option
      {...props}
    >
      <StyledOptionContainer disabled={isDisabled}>
        {shouldShowCheckbox && <Checkbox checked={isDisabled} disabled={isDisabled} />}
        <StyledIconContainer backgroundColor={color}>
          {icon as unknown as React.ReactNode}
        </StyledIconContainer>
        <StyledOptionName>
          {label}
        </StyledOptionName>
        {
          (toolTipProps && toolTipProps.content)
            ? (
              <Tooltip
                content={toolTipProps.content}
                align="center"
                style={{ maxWidth: 185, fontSize: 12 }}
                side="right"
              >
                {Description}
              </Tooltip>
            ) : Description
        }
      </StyledOptionContainer>
    </MultiSelectComponents.Option>
  );
}
